import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d1be359"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "login_title" }, "ログイン", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "login_input_password" }
const _hoisted_9 = ["type", "value"]
const _hoisted_10 = {
  key: 1,
  class: "login_error_description"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<p class=\"login_error_description_text\" data-v-2d1be359>原因として以下が考えられます。総合窓口までお問い合わせください。</p><div class=\"login_error_description_caution\" data-v-2d1be359><p class=\"login_error_description_caution_item\" data-v-2d1be359>過去に当社の転職支援サービスを利用し、現在利用を停止している。</p><p class=\"login_error_description_caution_item\" data-v-2d1be359>登録メールアドレスもしくはパスワードに誤りがある。</p> など </div><div class=\"login_error_description_contact\" data-v-2d1be359><p class=\"login_error_description_contact_title\" data-v-2d1be359>＜総合窓口＞</p><p class=\"login_error_description_contact_mail\" data-v-2d1be359><span class=\"login_error_description_contact_mail_title\" data-v-2d1be359>メール</span><a class=\"text_link\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-2d1be359>webmaster@massmedian.co.jp</a></p><p class=\"login_error_description_contact_text\" data-v-2d1be359> 原則として営業時間の範囲内でご返答してまいります。 <br data-v-2d1be359> 営業時間外にいただいたお問い合わせは翌営業日より順次対応いたします。 <br data-v-2d1be359> 予めご了承ください。 <br data-v-2d1be359> 【営業時間】10:00〜18:00（年末年始、土・日曜日、祝日、当社休業日を除く） </p></div>", 3)
const _hoisted_14 = [
  _hoisted_11
]
const _hoisted_15 = { class: "login_button_block" }
const _hoisted_16 = { class: "login_password_forgot" }
const _hoisted_17 = { class: "restart_account" }
const _hoisted_18 = { class: "login_signup" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login_signup_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "login_signup_title_text" }, "登録がお済みでない方")
], -1))

import axios from 'axios';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { postAuthLogin } from '@/api/accountEndpoint';
import { validationRuleHelper } from '@/utils/validationRule';
import store from '@/store';
import { getNotice } from '@/api/noticeEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();

// ログイン済の場合はhomeに飛ばす
if (localStorage.getItem('accessToken') || localStorage.getItem('refreshToken')) {
  router.push({ name: 'f00' });
}

const isErrorResponse = ref(false);
const isLoading = ref(false);

const { meta } = useForm();
const { value: email } = useField<string>('email', validationRuleHelper({ required: true }));
const { value: password } = useField<string>('password', validationRuleHelper({ required: true }));
const updateEmail = (e: Event) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value.replace(/</g, '＜');
  target.value = target.value.replace(/>/g, '＞');
  email.value = target.value;
};
const updatePassword = (e: Event) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value.replace(/</g, '＜');
  target.value = target.value.replace(/>/g, '＞');
  password.value = target.value;
};

const loginAction = async () => {
  isLoading.value = true;
  try {
    const res = await postAuthLogin({
      emailAddress: email.value,
      password: password.value,
    });

    if (res.data.restartAccountFlg) {
      router.push({ name: 'a31'});
    } else {
      const loginTransitionPageData = store.getters['router/loginTransitionPageData'];

      store.commit('router/initLoginTransitionData');
      router.push(loginTransitionPageData);
    };
  } catch (error) {
    isErrorResponse.value = true;
    console.error('error', error);
    if (axios.isAxiosError(error) && error.response?.data.status === 403) {
      console.error(error.response?.data);
    }
  } finally {
    isLoading.value = false;
  }
};

const isPasswordHidden = ref(true);
const togglePasswordIcon = () => {
  isPasswordHidden.value = !isPasswordHidden.value;
};
const iconType = computed(() => {
  return isPasswordHidden.value ? 'icon_eye_open' : 'icon_eye_close';
});
const inpuType = computed(() => {
  return isPasswordHidden.value ? 'password' : 'text';
});
const transitionEntryBase = () => {
  router.push({ name: 'b11' });
};

// マイページお知らせ取得
const title = ref('');
const noticeUrl = ref('');
const init = async () => {
  const res = await getNotice();
  title.value = res.title;
  noticeUrl.value = res.noticeUrl;
};
init();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(loginAction, ["prevent"]),
      class: "login_contents_wrapper"
    }, [
      (title.value !== null && noticeUrl.value !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("a", {
              href: `${noticeUrl.value}`,
              class: "text_link_outbound input_title_link",
              target: "_blank"
            }, _toDisplayString(title.value), 9, _hoisted_4),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("div", {
        class: _normalizeClass(["login_input", !isErrorResponse.value ? '' : 'is-error'])
      }, [
        _createElementVNode("input", {
          class: "login_input_mail_form",
          type: "mail",
          placeholder: "メールアドレス",
          value: _unref(email),
          onInput: updateEmail
        }, null, 40, _hoisted_7),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("input", {
            class: "login_input_password_form",
            type: _unref(inpuType),
            placeholder: "パスワード",
            value: _unref(password),
            onInput: updatePassword
          }, null, 40, _hoisted_9),
          _createElementVNode("span", {
            onClick: togglePasswordIcon,
            class: _normalizeClass(["login_input_password_icon", _unref(iconType)])
          }, null, 2)
        ]),
        (isErrorResponse.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: ['ログインエラーです']
            }))
          : _createCommentVNode("", true),
        (isErrorResponse.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "submit",
          disabled: !_unref(meta).valid
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, {
          class: "text_link",
          to: { name: 'a20' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワードをお忘れの方")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          class: "text_link",
          to: { name: 'q01' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("転職支援サービスの再開をご希望の方")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(BaseButton, {
          onClick: transitionEntryBase,
          theme: "secondary",
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("転職支援サービスお申し込み（無料）")
          ]),
          _: 1
        })
      ])
    ], 40, _hoisted_1)
  ]))
}
}

})